import { useQuery } from '@tanstack/react-query';
import { globalConfigServices } from 'features/globalConfiguration/services/globalConfig.service';

export const useGlobalConfig = () => {
  return useQuery({
    queryKey: ['globalConfig'],
    queryFn: () => globalConfigServices.getGlobalConfig(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};